import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrVikramSinghcontent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Vikram Singh"
      specialization="Your Expert & Confidante"
      experience="16 Years"
      degrees="MBBS, DGO (Obs & Gyn)"
      quote="I believe I am becoming a pregnancy crafter who replaces fear with understanding."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "I see myself as a translator and an educator. The world of medicine can be intimidating. I break down complex information into simple, understandable terms. I believe in empowering you to make informed decisions about your body and your baby. No question is too small or too basic. My greatest satisfaction comes from seeing a mother's anxiety melt away as she gains a clear understanding of her own journey.",
        },
        {
          title: "Why I Chose Myprega",
          body: "The educational material and proactive communication that Myprega provides is revolutionary. They have built the framework I always wished I had: a way to consistently educate and support mothers outside the limited time of an appointment. We are truly proactive here, not just reactive.",
        },
        {
          title: "Beyond the Clinic",
          body: "I'm a history buff and love listening to podcasts on my commute. I also practice mindfulness meditation daily, which helps me stay present and focused, both in my personal life and with my patients. I'm currently reading Sapiens by Yuval Noah Harari.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "Sapiens - A Brief History of Humankind" },
        { icon: "🎵", label: "Favourite Singer", value: "Lata Mangeshkar" },
        { icon: "🍽️", label: "Favourite Pastime", value: "Semi-classical music\nGardening" },
      ]}
    />
  );
};

export default DrVikramSinghcontent;
